module.exports = __webpack_public_path__ + "img/early_access_banner.e6b3b961.png";